export default __webpack_public_path__ + "static/media/sparkles-4.3f6151db.svg";